import { Outlet, Navigate } from "react-router-dom";

const TenantLoginAuth = () => {
  const isAuthenticated = Boolean(localStorage.getItem("auth_token_admin"));

  return !isAuthenticated ? <Outlet /> : <Navigate to="/dashboard" />;
};

export default TenantLoginAuth;
